import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store';

// Layout
import AppShell from './components/layout/AppShell';

// Public
import Landing  from './pages/Landing';
import Login    from './pages/Login';
import Register from './pages/Register';

// Sender pages
import Dashboard  from './pages/sender/Dashboard';
import SendRemesa from './pages/sender/SendRemesa';
import History    from './pages/sender/History';
import Contacts   from './pages/sender/Contacts';
import Wallet     from './pages/sender/Wallet';
import KYC        from './pages/sender/KYC';
import TwoFactorSetup from './pages/sender/TwoFactorSetup';
import GiftCards  from './pages/sender/GiftCards';

// Admin pages
import AdminOverview     from './pages/admin/AdminOverview';
import AdminTransactions from './pages/admin/AdminTransactions';
import AdminAgents       from './pages/admin/AdminAgents';
import AdminUsers        from './pages/admin/AdminUsers';
import AdminCompliance   from './pages/admin/AdminCompliance';
import AdminEscrow from './pages/admin/AdminEscrow';
import AdminTrust from './pages/admin/AdminTrust';

// Agent pages
import AgentDashboard   from './pages/agent/AgentDashboard';
import AgentMarketplace from './pages/agent/AgentMarketplace';
import BrowseAgents     from './pages/sender/BrowseAgents';
import P2PMarket       from './pages/sender/P2PMarket';
import AgentApply       from './pages/agent/AgentApply';

import './styles/global.css';

// ── Guards ───────────────────────────────────────────────────────────────────


function LandingOrDashboard() {
  const token = useAuthStore((s) => s.token);
  return token ? <Navigate to="/app/dashboard" replace /> : <Landing />;
}

function RequireAuth({ children }) {
  const token = useAuthStore((s) => s.token);
  return token ? children : <Navigate to="/login" replace />;
}

// Si ya está autenticado, redirige fuera del login/landing
function PublicOnly({ children }) {
  const token = useAuthStore((s) => s.token);
  return token ? <Navigate to="/app/dashboard" replace /> : children;
}

// ── Router ───────────────────────────────────────────────────────────────────

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ── Pública: landing page ── */}
        <Route path="/" element={<LandingOrDashboard />} />

        {/* ── Auth (redirige si ya tiene sesión) ── */}
        <Route path="/login"    element={<PublicOnly><Login /></PublicOnly>} />
        <Route path="/registro" element={<PublicOnly><Register /></PublicOnly>} />

        {/* ── App privada ── */}
        <Route path="/app" element={<RequireAuth><AppShell /></RequireAuth>}>
          <Route path="dashboard"   element={<Dashboard />} />
          <Route path="enviar"      element={<SendRemesa />} />
          <Route path="historial"   element={<History />} />
          <Route path="contactos"   element={<Contacts />} />
          <Route path="wallet"      element={<Wallet />} />
          <Route path="kyc"         element={<KYC />} />
          <Route path="2fa"          element={<TwoFactorSetup />} />
          <Route path="giftcards"   element={<GiftCards />} />

          <Route path="admin"            element={<AdminOverview />} />
          <Route path="admin/txs"        element={<AdminTransactions />} />
          <Route path="admin/agentes"    element={<AdminAgents />} />
          <Route path="admin/usuarios"   element={<AdminUsers />} />
          <Route path="admin/compliance" element={<AdminCompliance />} />
          <Route path="admin/escrow" element={<AdminEscrow />} />
          <Route path="admin/trust" element={<AdminTrust />} />

          <Route path="agent"         element={<AgentDashboard />} />
          <Route path="agent/pending" element={<AgentDashboard />} />
          <Route path="agente"        element={<AgentApply />} />
          <Route path="agentes"       element={<BrowseAgents />} />
          <Route path="mercado"       element={<AgentMarketplace />} />
          <Route path="p2p"           element={<P2PMarket />} />
        </Route>

        {/* ── Fallback ── */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </BrowserRouter>
  );
}
